import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card.tsx';
import { UsersTable } from '../components/users-table/UsersTable.tsx';
import type { UsersTableScope } from '../components/users-table/types.ts';

/** Module-level so the reference is stable across renders. */
const ALL_USERS_SCOPE: UsersTableScope = { mode: 'all' };

/**
 * User Management.
 *
 * A shell: one card, directly under the breadcrumb, wrapping the shared
 * `UsersTable` — the same layout `CustomersPage` uses, so the table gets the
 * full content width instead of sitting under a separate page heading.
 * Columns, filters, row actions, dialogs and the loading/error/empty states
 * all belong to the table, which both `/users` and the customer detail page
 * share — so the two surfaces cannot drift apart again.
 */
export function UsersPage() {
  return (
    <div className='space-y-6'>
      <Card>
        <CardHeader>
          <CardTitle>User Management</CardTitle>
          <CardDescription>
            Manage Waterscope Plus customer accounts
          </CardDescription>
        </CardHeader>
        <CardContent>
          <UsersTable scope={ALL_USERS_SCOPE} />
        </CardContent>
      </Card>
    </div>
  );
}
